export const findSideRatio = (
  side: number,
  firstRatio: number,
  secondRatio: number
) => {
  return (side * firstRatio) / secondRatio
}
